import React, { Component } from 'react';
import axios from '../../axios';
import moment from 'moment';
import FormDropdown from '../../components/FormDropdown';
import DatePicker from 'react-datepicker';
import qs from 'qs';
import queryString from 'query-string';
import Alert from 'react-s-alert';
import Paging from '../../components/Paging'
import fp from 'lodash/fp'
import { Nav } from 'reactstrap';
import NavLink from 'react-router-dom/NavLink';
import XLSX from 'xlsx'
import ModalHelp from "../../components/ModalHelp";

class ListsMapel extends Component {

    constructor(){
        super();
        this.state = {
            dataKelas : [],
            dataMapel : [],
            dataGuru : [],
            dataReport : [],
            pageCount : 0,
            currentPage : 0,
            user_id : "",
            kelas_id : "",
            mapel_id : "",
            dateNowStart : moment().format('YYYY-MM-DD'),
            dateNowEnd : moment().add(1, 'days').format('YYYY-MM-DD'),
            dateStart : moment(),
            dateEnd : moment(),
            isLoading : true,
            tutorial: '',
            isModalHelpShow  : false,
            isButtonLoading: false,
            isModalShow : false,
        }

        this.handleChangeDatepickerStart = this.handleChangeDatepickerStart.bind(this);
        this.handleChangeDatepickerEnd = this.handleChangeDatepickerEnd.bind(this);
        this.exportFile = this.exportFile.bind(this);
        this.handlePageClick = this.handlePageClick.bind(this);
        this.handleChange               = this.handleChange.bind(this)
        this.toggleModalHelp                = this.toggleModalHelp.bind(this)
    }

    toggleModalHelp() {

        this.setState({tutorial : 'https://www.youtube.com/embed/dT2hCKo649A'})

        this.setState({ isModalHelpShow: ! this.state.isModalHelpShow })
    }
    handleChange(event) {

        const target = event.target;
        const value  = target.value;
        const name   = target.name;

        this.setState({
            [name] : value,
        })

    }

    handleChangeDatepickerStart(e){
        this.setState({
            dateStart : e,
            dateNowStart : e.format('YYYY-MM-DD'),
            isLoading : true
        }, () => {
            this.loadData()
        })
    }

    handleChangeDatepickerEnd(e){
        this.setState({
            dateEnd : e,
            dateNowEnd : e.add(1, 'days').format('YYYY-MM-DD'),
            isLoading : true
        }, ()=> {
            this.loadData()
        })
    }

    handlePageClick(data) {

        let selected = data.selected; // zero based index

        this.setState({currentPage: selected}, () => {
            this.loadData();
        });
    };

    loadDataKelas(){
        axios.post("/kelas")
            .then(response => {
                return response.data.data.map(item => ({
                    key : item.kelas_id,
                    value : item.kelas_nama
                }))
            })
            .then(result => {
                this.setState({
                    dataKelas: result,
                })
            })
            .catch(error => {
                console.log(error)
            })
    }

    loadDataMapel(){
        axios.post("/mapel")
        .then(response => {
            return response.data.data.map(item => ({
                key: item.mapel_id,
                value : item.mapel_nama
            }))
        })
        .then(result => {
            this.setState({
                dataMapel: result
            })
        })
        .catch(error => {
            console.log("Mapel Undefinded")
        })
    }

    loadDataGuru(){

        axios.post("/user?level=guru")
        .then(response => {
            return response.data.data.map(item => ({
                key: item.user_id,
                value : item.user_nama
            }))
        })
        .then(result => {
            this.setState({
                dataGuru : result
            })
        })
        .catch(error => {
            console.log("Guru Undefinded")
        })
    }

    loadData(){

        this.setState({ isLoading: true, isButtonLoading:true })

        const params = qs.stringify({
            page: this.state.currentPage + 1,
            kelas : this.state.kelas_id,
            mapel : this.state.mapel_id,
            user : this.state.user_id,
            tglMulai : this.state.dateNowStart,
            tglEnd : this.state.dateNowEnd,
        })

        axios.post("/reportmapel?" + params)
            .then(response => {
                const result = response.data

                this.setState({
                    dataReport : result.data.data,
                    pageCount : result.data.last_page,
                    isLoading : false,
                    isButtonLoading:false
                })

            })
            .catch((error) => {
                this.setState({ isLoading: true, isButtonLoading:true })
                Alert.error("Gagal terhubung ke server !")
            })

    }

    exportFile() {
        let presensi = [["Nama Guru", "Kelas", "Mapel", "Siswa Hadir", "Siswa Tidak Hadir", "Tanggal", "Note"]]
        this.state.dataReport.map(item => {
          presensi.push([item.user_nama,
                        item.kelas_nama,
                        item.mapel_nama,
                        item.siswa_hadir,
                        item.siswa_off,
                        moment(item.pg_create_date).format("DD MMMM YYYY - h:m:s A"),
                        item.note
                    ])
        })
        const wb = XLSX.utils.book_new()
        const wsAll = XLSX.utils.aoa_to_sheet(presensi)
            XLSX.utils.book_append_sheet(wb, wsAll, "All Users")
            XLSX.writeFile(wb, "Rekap Presensi Guru Per Jadwal-"+ moment().format('DD-MMMM-YYYY') +".xlsx")
      }


    componentDidMount(){
        this.loadDataKelas();
        this.loadDataMapel();
        this.loadDataGuru();
        this.loadData();
    }

    componentDidUpdate(prevProps, prevState) {

        if (prevState.kelas_id !== this.state.kelas_id ||
            prevState.mapel_id !== this.state.mapel_id ||
            prevState.user_id !== this.state.user_id ) {
            this.loadData()
        }
    }


    render(){

        // const urlParams = queryString.parse(this.props.location.search);

        return(
            <div className="col-sm-12">
                <ModalHelp
                    isShow={this.state.isModalHelpShow}
                    toggleModal={this.toggleModalHelp}
                    handleSubmit={this.handleSubmitDeleteButton}
                    modalHeaderText="Tutorial Penggunaan Fitur"
                    modalBodyText={this.state.tutorial}
                    modalSubmitText="Ya" />
                <div className="card">
                    <div className="card-header">
                        Report Absensi Mata pelajaran
                        <button
                            type="button"
                            title='Tutorial'
                            className="btn btn-danger btn-sm"
                            style={{ float: 'right'}}
                            onClick={() => {
                                this.toggleModalHelp();
                                // this.setState({ tutorial: levelName});
                            }}
                        >
                            <i className="fa fa-question-circle"s></i>
                        </button>
                    </div>
                    <div className="card-block">
                        <div className="form-group row">
                            <div className="col-md-2">
                                <FormDropdown
                                    items = {this.state.dataGuru}
                                    onChange = {this.handleChange}
                                    value={this.state.user_id.toString()}
                                    placeholder={"Pilih Guru"}
                                    name="user_id"
                                    disabled={this.state.isLoading}
                                />
                            </div>

                            <div className="col-md-2">
                                <FormDropdown
                                    items={this.state.dataKelas}
                                    onChange={this.handleChange}
                                    value={this.state.kelas_id.toString()}
                                    placeholder={"Pilih Kelas"}
                                    name="kelas_id"
                                    disabled={this.state.isLoading}
                                />
                            </div>

                            <div className="col-md-2">
                                <FormDropdown
                                    items = {this.state.dataMapel}
                                    onChange = {this.handleChange}
                                    value={this.state.mapel_id.toString()}
                                    placeholder={"Pilih Mapel"}
                                    name="mapel_id"
                                    disabled={this.state.isLoading}
                                />
                            </div>

                            <div className="col-md-2">
                                {
                                    <DatePicker
                                        selected={this.state.dateStart}
                                        onChange={this.handleChangeDatepickerStart}
                                        showYearDropdown
                                        scrollableYearDropdown
                                        yearDropdownItemNumber={15}
                                        disabled={this.state.isLoading}
                                    />
                                }
                            </div>

                            <div className="col-md-2">
                                {
                                    <DatePicker
                                        selected={this.state.dateEnd}
                                        onChange = {this.handleChangeDatepickerEnd}
                                        showYearDropdown
                                        scrollableYearDropdown
                                        yearDropdownItemNumber={15}
                                        disabled={this.state.isLoading}
                                    />
                                }
                            </div>

                            <div className="col-md-2">
                                <button
                                    className="btn btn-primary"
                                    disabled={this.state.isButtonLoading && "disabled" || this.state.dataReport.length === 0 && "disabled"}
                                    onClick={this.exportFile}>
                                    {this.state.isButtonLoading || this.state.dataReport.length === 0 ? "Menyiapkan file..." : "Export Presensi"}
                                </button>
                            </div>

                        </div>
                        <hr/>
                        {
                            this.state.isLoading ? (
                                <div className="alert alert-danger" role="alert">
                                    <div className="loader" style={{
                                        width:'20px',
                                        height:'20px',
                                        marginLeft:'0px',
                                        border: '5px solid rgba(0, 0, 0, 0.2)',
                                        borderLeft: '5px solid #000000'
                                    }}></div>
                                    Memuat data..
                                </div>
                            ) : (
                                this.state.dataReport.length === 0 ? "Data tidak ditemukan..." : (
                                    <div>
                                        <table className="table table-striped table-bordered animated fadeIn">
                                            <thead>
                                                <tr>
                                                    <th width="20">No</th>
                                                    <th>Nama Guru</th>
                                                    <th>Kelas</th>
                                                    <th>Mata Pelajaran</th>
                                                    <th>Siswa Hadir</th>
                                                    <th>Siswa Tdk Hadir</th>
                                                    <th>Tgl. Mengajar</th>
                                                    <th>Opsi</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                            {
                                                this.state.dataReport.map((item, i) => {
                                                    return (
                                                        <tr key={item.pg_id}>
                                                            <td>{i + 1}</td>
                                                            <td>{item.user_nama}</td>
                                                            <td>{item.kelas_nama}</td>
                                                            <td>{item.mapel_nama}</td>
                                                            <td>{item.siswa_hadir}</td>
                                                            <td>{item.siswa_off}</td>
                                                            <td>{moment(item.pg_create_date).format("DD MMMM YYYY - h:m:s A")}</td>
                                                            <td>
                                                                <NavLink
                                                                    to={`${this.props.match.url}/view/${item.pg_id}`}
                                                                    className="btn btn-secondary btn-sm"
                                                                >View</NavLink>
                                                            </td>
                                                        </tr>
                                                    )
                                                })
                                            }
                                            </tbody>
                                        </table>
                                        <Paging
                                            handlePageClick={this.handlePageClick}
                                            pageCount={this.state.pageCount}
                                            currentPage={this.state.currentPage}
                                        />
                                    </div>
                                )
                            )
                        }

                    </div>
                </div>
            </div>
        );
    }
}

export default ListsMapel;



// WEBPACK FOOTER //
// ./src/views/ReportPresensi/ListsMapel.js